import { css, type Interpolation, type Theme } from '@emotion/react';

type ListCardProps = React.PropsWithChildren<{
  /** Optional Emotion styles to merge on top of the base card styles. */
  css?: Interpolation<Theme>;
  className?: string;
}>;

const baseStyles = css`
  width: 100%;
  padding: var(--fabric-space-padding-sm);
  border: 1px solid var(--fabric-color-border-subtle);
  border-radius: var(--fabric-radius-md);
  background-color: var(--fabric-color-background-default);
  box-shadow: var(--fabric-card-shadow);
`;

/**
 * Base card wrapper for audit event entries in the history details tray to apply base card styles.
 *
 * Accepts an optional `css` prop to extend or override base styles.
 */
export const ListCard = ({ children, css: additionalStyles, className }: ListCardProps) => (
  <div className={className} css={[baseStyles, additionalStyles]}>
    {children}
  </div>
);
